import {
  AUTHENTICATE_USER_SUCCESS,
  SIGN_IN_USER,
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCSESS,
  RESET_ACCOUNT_PASSWORD_SUCCESS,
  RESET_ACCOUNT_PASSWORD_FAILED,
  UPDATE_PERSONAL_DETAILS_SUCCESS,
  SET_NOT_FIRST_TO_SELECT_PAGE,
  LOG_OUT,
} from '../constants';

import { getCredentials } from '../../utilities/localStorage';
import { decodeToken } from '../../utilities/helpers';

const storedCredentials = getCredentials();

const initialState = {
  authenticationInProgress: false,
  resetPasswordInProgress: false,
  resetPasswordSuccess: false,
  isAuthenticated: storedCredentials.credentialsPresent,
  authenticationFailed: false,
  resetAccountPasswordInProgress: true,
  server: process.env.REACT_APP_API_DOMAIN,
  audienceBuilderServer: process.env.REACT_APP_AUDIENCEBUILDER_SERVER_URL ,
  token: `Bearer ${storedCredentials.token}` || null,
  firstName: storedCredentials.firstName || null,
  lastName: storedCredentials.lastName || null,
  expiresAt: storedCredentials.expiresAt || null,
  tokenPayload: storedCredentials.token ? decodeToken(storedCredentials.token) : null,
  accounts:  storedCredentials.accounts ? JSON.parse(storedCredentials.accounts) : [],
  currentAccountIndex :  Number(storedCredentials.currentAccountIndex) || 0,
  firstToSelectPage: storedCredentials.firstToSelectPage
       ?  storedCredentials.firstToSelectPage === 'true'
       :  true,
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTHENTICATE_USER_SUCCESS:
      return {
        ...state,
        tokenPayload: decodeToken(action.token),
        isAuthenticated: true,
        authenticationInProgress: false,
        token: action.token,
        resetPasswordSuccess: false,
        currentAccountIndex: action.selectedIdx,
      };
    case RESET_ACCOUNT_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordSuccess: true,
      };
    case UPDATE_PERSONAL_DETAILS_SUCCESS:
      return {
        ...state,
        firstName: action.data.user.firstName,
        lastName: action.data.user.lastName,
      };
    case SIGN_IN_USER:
      return {
        ...state,
        authenticationInProgress: true,
      }
    case SIGN_IN_SUCCSESS:
      return {
        ...state,
        accounts: action.data.accounts,
        firstName: action.data.user.firstName,
        lastName: action.data.user.lastName,
        token: `Bearer ${action.data.accounts[0].token}` ,
        tokenPayload: decodeToken(action.data.accounts[0].token),
        isAuthenticated:true,
        expiresAt: action.data.accounts[0].expiresAt
      }
    case SIGN_IN_FAILURE:
      return {
        ...state,
        authenticationFailed: true,
        authenticationInProgress: false,
        resetPasswordSuccess: false,
      };
    case RESET_ACCOUNT_PASSWORD_FAILED:
      return {
        ...state,
        resetAccountPasswordInProgress: false,
      };
    case SET_NOT_FIRST_TO_SELECT_PAGE:
      return{
        ...state,
        firstToSelectPage: false,
      }
    case LOG_OUT:
      return {
        ...state,
        isAuthenticated: false,
        authenticationInProgress: false,
        token: null,
        firstName: null,
        lastName: null,
        tokenPayload: null,
        firstToSelectPage: true
      };
    default:
      return state;
  }
};

export default auth;
